/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m28.3262 23.7822c-.051.122-.124.232-.216.323l-6.601 6.602c-.196.195-.452.293-.707.293-.256 0-.512-.098-.707-.293-.391-.391-.391-1.024 0-1.414l4.895-4.896h-20.693c-.553 0-1-.447-1-1 0-.552.447-1 1-1h20.693l-4.895-4.894c-.391-.391-.391-1.024 0-1.414.39-.391 1.023-.391 1.414 0l6.601 6.6c.092.091.165.201.216.323s.078.251.078.385-.027.264-.078.385zm-26.249-14.795c-.05-.12-.077-.251-.077-.385 0-.133.027-.264.077-.384.051-.123.125-.232.217-.324l6.601-6.601c.391-.391 1.024-.391 1.414 0 .391.39.391 1.023 0 1.414l-4.895 4.895h20.693c.553 0 1 .448 1 1 0 .553-.447 1-1 1h-20.693l4.895 4.895c.391.39.391 1.023 0 1.414-.195.195-.451.293-.707.293-.255 0-.511-.098-.707-.293l-6.601-6.601c-.092-.091-.166-.201-.217-.323z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;